import ItemWrapper from 'modules/stores/store/components/item-wrapper'
import { HeaderItemViewType } from 'modules/stores/store/content/header/types/header-interface'
import { useDeleteItem } from 'modules/stores/store/hooks/use-delete-item'
import HeaderItemContent from '../../components/header-item-content'
import { useActions } from './hooks/use-actions'

const HeaderContent = (item: HeaderItemViewType) => {
  const { deleteHeader } = useActions()

  const { onDelete } = useDeleteItem()

  const onDeleteHeader = () =>
    onDelete({ deleteCallback: () => deleteHeader(item.id), itemId: item.itemId })

  return (
    <ItemWrapper id={item.itemId}>
      <HeaderItemContent onDelete={onDeleteHeader} id={item.id} title={item.text} />
    </ItemWrapper>
  )
}

export default HeaderContent
